export const STRIPE_CUSTOMER_TEXTS = {
    CREATE_PAYMENT_METHOD_SUCCEEDED: 'Your new payment method was saved successfully',
    CREATE_PAYMENT_METHOD_FAILD: 'Something went wrong while saving your new payment method',
    CREATE_OR_UPDATE_STRIPE_CUSTOMER_FAILED: 'There was an problem when trying to update your payment method. Please try again in a few seconds.',
};
